function Message({error}) {
  return <div className="error-message">{error}</div>;
}

export default Message;
